import axiosInstance from '../axiosInterceptor/axiosInstance'

const getPayments = async (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}/billing/orders`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getPayments
